import React from 'react';
import PropTypes from 'prop-types';
import {parse} from 'query-string';
import {connect} from 'react-redux';
import {fetchChapterReport} from 'storyboard/actions/chapter-report-actions';
import StoryboardChapter from 'storyboard/components/storyboard-chapter';

class StoryboardChapterContainer extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    enums: PropTypes.object.isRequired,
    isAutoplaying: PropTypes.bool,
    location: PropTypes.object.isRequired,
    nextChapter: PropTypes.func,
    report: PropTypes.object.isRequired,
    theme: PropTypes.object,
  };

  static defaultProps = {
    dispatch: () => {},
    isAutoplaying: false,
    nextChapter: () => {},
  };

  UNSAFE_componentWillMount() {
    this.dispatchFetchChapterReportAction(
      this.props.location,
      this.props.dispatch,
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentChapterId = parse(this.props.location.search).chapterId;
    const nextChapterId = parse(nextProps.location.search).chapterId;
    if (nextChapterId !== currentChapterId) {
      this.dispatchFetchChapterReportAction(
        nextProps.location,
        nextProps.dispatch,
      );
    }
  }

  dispatchFetchChapterReportAction(location, dispatch) {
    let {chapterId} = parse(location.search);
    chapterId = parseInt(chapterId, 10);
    if (chapterId) {
      dispatch(fetchChapterReport(chapterId));
    }
  }

  render() {
    return (
      <StoryboardChapter
        data={this.props.data}
        enums={this.props.enums}
        isAutoplaying={this.props.isAutoplaying}
        location={this.props.location}
        nextChapter={this.props.nextChapter}
        report={this.props.report}
      />
    );
  }
}

export default connect()(StoryboardChapterContainer);
